import { useLocation, useNavigate } from "react-router-dom";
import arrow from "../../assets/images/icons/arrow-down.svg";
import { useTranslation } from "react-i18next";

function TitleWithArrowLink({
  title,
  route,
  isWhiteArrow,
}: {
  title: string;
  route?: string;
  isWhiteArrow?: boolean;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();

  const handleBack = () => {
    navigate(location.state?.from || -1);
  };
  const handleClick = () => {
    if (route) {
      navigate(route);
    } else {
      handleBack();
    }
  };
  return (
    <div
      onClick={handleClick}
      className={`${isWhiteArrow ? "" : "mb-2"} text-primary-textFont flex cursor-pointer items-center gap-2`}
    >
      {isWhiteArrow ? (
        <div className="h-6 w-6 rotate-90 rounded-full bg-primary rtl:-rotate-90">
          <img src={arrow} alt="" className="brightness-0 invert" />
        </div>
      ) : (
        <img src={arrow} alt="arrow" className="ltr:rotate-90 rtl:-rotate-90" />
      )}
      <h1 className={`${isWhiteArrow ? "text-xl" : "text-lg"} font-bold`}>
        {t(title)}
      </h1>
    </div>
  );
}

export default TitleWithArrowLink;
